import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=62b01fa6&scoped=true&"
import script from "./GeneralTab.vue?vue&type=script&lang=js&"
export * from "./GeneralTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=62b01fa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b01fa6",
  null
  
)

export default component.exports